import { useAppDispatch, useAppSelector } from "@app/hooks";
import type { Authentication } from "@features/auth/types";
import { setCredentials } from "@features/auth/userSlice";
import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading, loggingOut } = useAppSelector(
    (state) => state.user,
  );
  const dispatch = useAppDispatch();
  const location = useLocation();
  const storedToken = localStorage.getItem("accessToken");

  useEffect(() => {
    if (storedToken && !isAuthenticated) {
      const userData: Authentication = {
        clientId: 0,
        accessToken: storedToken,
        clientLogo: "",
        clientName: "",
        displayName: localStorage.getItem("displayName") || "",
        domain: "",
        email: localStorage.getItem("email") || "",
        environmentName: "",
        firstName: localStorage.getItem("firstName") || "",
        firstTimeLogin: 0,
        lastName: localStorage.getItem("lastName") || "",
        message: "",
        organizationCode: "",
        refreshToken: localStorage.getItem("refreshToken") || "",
        regionID: 0,
        sessionExpiryMillis: 0,
        sessionId: "",
        tokenCreated: "",
        userID: localStorage.getItem("userID") || "",
        loginMethod: Number(localStorage.getItem("loginMethod")) || 0,
        user: {
          imageData: "",
          lastName: localStorage.getItem("lastName") || "",
          firstName: localStorage.getItem("firstName") || "",
          id: localStorage.getItem("userID") || "",
          office: localStorage.getItem("office") || "",
          locationCode: "",
          streetAddress: "",
          city: "",
          state: "",
          country: "",
          postalCode: "",
          employeeId: localStorage.getItem("employeeId") || "",
          position: localStorage.getItem("position") || "",
          employeeName: localStorage.getItem("displayName") || "",
          emailAddress: localStorage.getItem("email") || "",
          localPreferredName: "",
          managingOffice: "",
          lineofbusiness: "",
          userPrincipalName: "",
          marketingLineOfBusiness: "",
          functUnitName: localStorage.getItem("functUnitName") || "",
        },
      };
      dispatch(setCredentials(userData));
    }
  }, [storedToken, isAuthenticated, dispatch]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated && !storedToken && !loggingOut) {
    // Store the current location before redirecting to login
    localStorage.setItem("returnUrl", location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
